export default "__VITE_ASSET__4dcb8922__"